import { useState, useEffect } from "react";
import { Box, Typography, Grid } from "@mui/material";
import QRCode from "qrcode.react";
import useHttp from "../../Hooks/use-http";

const QrCodeCard = ({ value, title, link }) => {
  const handleDownloadClick = () => {
    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box
      sx={{
        textAlign: "center",
        position: "relative",
        transition: "transform 0.3s",
        "&:hover": { transform: "translateY(-5px)" },
        p: 2,
        borderRadius: 3,
        background: "transparent",
        maxWidth: "280px",
        margin: "0 auto",
      }}
    >
      {/* Android Phone Frame */}
      <Box
        sx={{
          position: "relative",
          display: "inline-block",
        }}
      >
        {/* Phone Frame Container - Android Style */}
        <Box
          sx={{
            position: "relative",
            width: "220px",
            height: "420px",
            background: "linear-gradient(135deg, #2c2c2c 0%, #1a1a1a 100%)",
            borderRadius: "30px",
            padding: "10px 7px",
            boxShadow:
              "0 12px 40px rgba(0,0,0,0.5), inset 0 0 0 4px #3a3a3a, inset 0 0 0 6px #1a1a1a",
          }}
        >
          {/* Top Speaker */}
          <Box
            sx={{
              position: "absolute",
              top: "12px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "80px",
              height: "5px",
              background: "#0a0a0a",
              borderRadius: "3px",
              zIndex: 2,
            }}
          />

          {/* Screen - Android Style */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              background: "linear-gradient(180deg, #f5f5f5 0%, #ffffff 100%)",
              borderRadius: "22px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "25px 18px 20px 18px",
              overflow: "hidden",
              border: "2px solid #e0e0e0",
              boxShadow: "inset 0 0 20px rgba(0,0,0,0.05)",
            }}
          >
            {/* Status Bar */}
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
                px: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                9:41
              </Typography>
              <Box sx={{ display: "flex", gap: 0.3, alignItems: "flex-end" }}>
                {/* Signal Bars */}
                <Box
                  sx={{
                    display: "flex",
                    gap: "1px",
                    alignItems: "flex-end",
                  }}
                >
                  <Box
                    sx={{
                      width: "2.5px",
                      height: "4px",
                      background: "#333",
                      borderRadius: "0.5px 0.5px 0 0",
                    }}
                  />
                  <Box
                    sx={{
                      width: "2.5px",
                      height: "6px",
                      background: "#333",
                      borderRadius: "0.5px 0.5px 0 0",
                    }}
                  />
                  <Box
                    sx={{
                      width: "2.5px",
                      height: "8px",
                      background: "#333",
                      borderRadius: "0.5px 0.5px 0 0",
                    }}
                  />
                  <Box
                    sx={{
                      width: "2.5px",
                      height: "10px",
                      background: "#333",
                      borderRadius: "0.5px 0.5px 0 0",
                    }}
                  />
                </Box>
                {/* Battery Icon */}
                <Box
                  sx={{
                    width: "18px",
                    height: "10px",
                    border: "1.5px solid #333",
                    borderRadius: "2px",
                    position: "relative",
                    ml: 0.5,
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      right: "-3px",
                      top: "2px",
                      width: "2px",
                      height: "6px",
                      background: "#333",
                      borderRadius: "0 1px 1px 0",
                    },
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      left: "1px",
                      top: "1px",
                      width: "12px",
                      height: "7px",
                      background: "#333",
                      borderRadius: "1px",
                    },
                  }}
                />
              </Box>
            </Box>
            {/* App Title */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: "var(--primary-color)",
                fontSize: "16px",
                mb: 0,
                textAlign: "center",
                transition: "all 0.3s",
              }}
            >
              {title || "App"}
            </Typography>

            {/* QR Code */}
            <div style={{ marginTop: "4px" }}>
              {value && (
                <QRCode
                  value={value}
                  size={150}
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              )}
            </div>

            {/* Download Button */}
            {link && (
              <button
                onClick={handleDownloadClick}
                style={{
                  padding: "10px 24px",
                  backgroundColor: "var(--primary-color)",
                  color: "white",
                  border: "none",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: "600",
                  transition: "all 0.3s",
                  width: "90%",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "var(--secondry-color)";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 6px 16px rgba(0,0,0,0.25)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "var(--primary-color)";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
                }}
              >
                Download App
              </button>
            )}

            {/* Bottom Navigation Indicator */}
            <Box
              sx={{
                width: "120px",
                height: "4px",
                background: "#ddd",
                borderRadius: "2px",
                mt: 1.5,
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const OurAppsSection = () => {
  const [appData, setAppData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { sendRequest } = useHttp();

  useEffect(() => {
    // Fetch app data from support API
    sendRequest(
      {
        url: "/getAppUrl",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: "deepak.pradhan@little.global",
          data: {
            applicationIDs: ["com.little.driver", "com.little.rider"],
          },
        },
      },
      (data) => {
        if (data.status === 200 || data.status === 201) {
          setAppData(data);
          console.log("App data received:", data);
        } else {
          console.error("Failed to fetch app data:", data);
        }
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching app data:", error);
        setIsLoading(false);
      }
    );
  }, []);

  return (
    <section
      className="our-apps-section padding-bottom"
      id="ourAppsSection"
      style={{
        background: "#ffffff",
        paddingTop: "30px",
        paddingBottom: "30px",
      }}
    >
      <div className="container">
        <div className="section-title">
          <h2>Our Apps</h2>
          {/* <p style={{ color: "#666", marginTop: "10px", fontSize: "16px" }}>
            Download our mobile applications and experience seamless mobility
            solutions
          </p> */}
        </div>

        {isLoading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="200px"
          >
            <Typography variant="h6" color="text.secondary">
              Loading apps...
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3} justifyContent="center" sx={{ mt: 1 }}>
            {appData?.rider && (
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <QrCodeCard
                  value={appData.rider.url}
                  title="Rider App"
                  link={appData.rider.url}
                />
              </Grid>
            )}

            {appData?.driver && (
              <Grid item xs={12} sm={6} md={6} lg={4}>
                <QrCodeCard
                  value={appData.driver.url}
                  title="Driver App"
                  link={appData.driver.url}
                />
              </Grid>
            )}

            {!appData?.rider && !appData?.driver && (
              <Grid item xs={12}>
                <Box textAlign="center" py={4}>
                  <Typography variant="body1" color="text.secondary">
                    Apps will be available soon
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        )}

        <Box mt={2} textAlign="center">
          <Typography
            variant="body2"
            sx={{
              color: "#666",
              fontSize: "12px",
              fontStyle: "italic",
            }}
          >
            Available on Android platforms
          </Typography>
        </Box>
      </div>
    </section>
  );
};

export default OurAppsSection;
